var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "DatePicker" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.date,
            expression: "date",
          },
        ],
        staticClass: "DatePicker__input",
        attrs: { type: "text" },
        domProps: { value: _vm.date },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            _vm.showPicker = true
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.date = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.showPicker
        ? _c("calendar", {
            directives: [
              {
                name: "outside",
                rawName: "v-outside",
                value: _vm.closeCalendar,
                expression: "closeCalendar",
              },
            ],
            attrs: { "is-range": "", date: _vm.date },
            on: {
              "date-handler": function (v) {
                return (_vm.date = v)
              },
              apply: function () {
                return (_vm.showPicker = false)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }